import { Alert, Box, Button, CircularProgress, Paper, Typography } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { GetLastResourcesRevisiones } from "../../../../hooks/partesRevisiones";
import { ImageViewer } from "../../../../components/FileDropper/imageViewer";
import { UploadFile } from "@mui/icons-material";

export const AyudasVisualesPanel = ({ id_part, setOpenAyudas, setAyudas, canClose = true }) => {


  const apiResources = useSelector((state) => state.app.apiResources);
  const { isLoading, isError, data, refetch } = GetLastResourcesRevisiones(id_part);
  const [openImage, setOpenImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const closeAyudas = () => {
    setOpenAyudas(false);
    setAyudas(null)
  }

  const handleImageClick = (imageUrl) => {
    let resUrl = `${apiResources}/${imageUrl}`
    setSelectedImage(resUrl);
    setOpenImage(true);
  }

  const handleCloseImage = () => {
    setOpenImage(false);
    setSelectedImage(null);
  }

  const handleOpenPDF = (pdfUrl) => {
    // let resUrl = `${apiResources}/${pdfUrl}`
    let resUrl = `https://docs.google.com/gview?url=${encodeURIComponent(`${apiResources}/${pdfUrl}`)}`;
    window.open(resUrl, '_blank');
  };


  return (
    <div className="contain_img_gen">
      {canClose &&
        <Button variant="contained" className="btn_system" onClick={closeAyudas} sx={{ mb: 1, width: '100%' }}>
          Cerrar Imagenes
        </Button>}
      {
        data && (
          <>
            <Typography variant="h6" sx={{ mb: 2 }}>
              {`Revision: ${data?.pare_nombre}`}
            </Typography>
            {
              data?.recursos?.length > 0 &&
              <>
                {
                  data?.recursos?.map(res => (
                    <div className="img_item_gen" key={`res_rev_${res?.recu_id}`}>
                      <Paper sx={{ p: 2, display: 'flex', alignItems: 'center', width: '100%' }}>
                        {res.recu_mime.startsWith('image') ? (
                          <Box
                            component="img"
                            src={`${apiResources}/${res?.recu_ruta}`}
                            alt={res?.recu_nombre}
                            sx={{
                              width: 60,
                              height: 60,
                              objectFit: 'cover',
                              mr: 2,
                              borderRadius: 1,
                            }}
                            onClick={() => handleImageClick(res?.recu_ruta)}
                          />
                        ) : (
                          <Box
                            sx={{
                              minWidth: 60,
                              height: 60,
                              mr: 2,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              bgcolor: 'grey.200',
                              borderRadius: 1,
                            }}
                            onClick={() => handleOpenPDF(res?.recu_ruta)}
                          >
                            <UploadFile />
                          </Box>
                        )}
                        <Box sx={{ width: '60%' }}>
                          <Typography noWrap sx={{ flexGrow: 1 }}>{res?.recu_nombre}</Typography>
                        </Box>
                      </Paper>
                    </div>
                  ))
                }
              </>
            }
            {
              data?.recursos?.length === 0 &&
              <Alert severity="warning" sx={{ width: '100%' }}>No existen recursos para esta revisión</Alert>
            }
          </>
        )
      }
      {
        isLoading &&
        <CircularProgress />
      }
      {
        !data && !isLoading &&
        <Alert severity="warning" sx={{ width: '100%' }}>No existen revisiones</Alert>
      }
      {isError &&
        <Alert severity="error" sx={{ width: '100%' }}>No se pudieron cargar las revisiones</Alert>
      }
      {
        openImage && selectedImage &&
        <ImageViewer
          key={`image_viewer_${id_part}`}
          open={openImage}
          handleClose={handleCloseImage}
          selectedImage={selectedImage}
        />
      }
    </div>
  )
}